import {IModelFactory} from "../ModelFactory";
import BrowseRouteFactory from "../../route/BrowseRouteFactory";
import AccountRouteFactory from "../../route/subject/AccountRouteFactory";
import LocatePageListRouteFactory from "../../route/locate/LocatePageListRouteFactory";
import LocateRouteFactory from "../../route/locate/LocateRouteFactory";
import EndRouteFactory from "../../route/simple/EndRouteFactory";
import LocatePageListDataFactory from "../../data/locate/LocatePageListDataFactory";
import LocateDataFactory from "../../data/locate/LocateDataFactory";
import LocateCountryDataFactory from "../../data/locate/LocateCountryDataFactory";
import OrganisationUserDataFactory from "../../data/subject/OrganisationUserDataFactory";
import MessageDataFactory from "../../data/subject/message/MessageDataFactory";
import MessagePageListDataFactory from "../../data/subject/message/MessagePageListDataFactory";
import MessageRouteFactory from "../../route/subject/message/MessageRouteFactory";
import MessagePageListRouteFactory from "../../route/subject/message/MessagePageListRouteFactory";
import MessageListRouteFactory from "../../route/subject/message/MessageListRouteFactory";
import PostRouteFactory from "../../route/subject/PostRouteFactory";
import PostListRouteFactory from "../../route/subject/PostListRouteFactory";
import MyProfileRouteFactory from "../../route/subject/MyProfileRouteFactory";
import PostDataFactory from "../../data/subject/PostDataFactory";
import PageDataFactory from "../../data/subject/PageDataDactory";
import PostActivityDataFactory from "../../data/subject/PostActivityDataFactory";
import PostEntryRouteFactory from "../../route/subject/PostEntryRouteFactory";
import PostStatusRouteFactory from "../../route/subject/PostStatusRouteFactory";
import SubPageRouteFactory from "../../route/SubPageRouteFactory";

export const modelFactoryConfig:IModelFactory = {
    browseRoute: new BrowseRouteFactory(),
    accountRoute: new AccountRouteFactory(),

    myProfileRoute: new MyProfileRouteFactory(),
    postRoute: new PostRouteFactory(),
    postListRoute: new PostListRouteFactory(),
    postEntryRoute: new PostEntryRouteFactory(),
    postStatusRoute: new PostStatusRouteFactory(),

    locateRoute: new LocateRouteFactory(),
    locatePageListRoute: new LocatePageListRouteFactory(),

    messageRoute: new MessageRouteFactory(),
    messagePageListRoute: new MessagePageListRouteFactory(),
    messageListRoute: new MessageListRouteFactory(),
    subPageRoute: new SubPageRouteFactory(),

    endRoute: new EndRouteFactory(),

    postData: new PostDataFactory(),
    pageData: new PageDataFactory(),
    postActivityData: new PostActivityDataFactory(),

    locateData: new LocateDataFactory(),
    locatePageListData: new LocatePageListDataFactory(),
    locateCountryData: new LocateCountryDataFactory(),
    messageData: new MessageDataFactory(),
    messagePageListData: new MessagePageListDataFactory(),
    organisationUserData: new OrganisationUserDataFactory(),
}